import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { Event } from '../../../support';
import { useStore } from '../../../store';
import HitsUsageDownload from './HitsUsageDownload';
import Table from '../../../facturotopia/table/Table';
import CalendarDateRangePicker from '../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

class HitsUsage extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: [],
      from: moment().subtract(7, 'days').toDate(),
      to: moment().toDate(),
    };

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
  }

  componentDidMount() {
    const { data } = this.props.hitsUsage;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      this.paginate({
        page: 1,
        from,
        to,
      });
    }

    window.setAppTitle('Hits');
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
  }

  get columns() {
    return [
      {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
      },
      {
        key: 'rfc',
        title: 'RFC',
        dataIndex: 'rfc',
      },
      {
        key: 'razon_social',
        title: 'Nombre',
        dataIndex: 'razon_social',
      },
      {
        key: 'comprobantes',
        title: 'Comprobantes',
        dataIndex: 'comprobantes',
        align: 'center',
      },
      {
        key: 'sector_primario',
        title: 'Sector primario',
        dataIndex: 'sector_primario',
        align: 'center',
      },
      {
        key: 'retenciones',
        title: 'Retenciones',
        dataIndex: 'retenciones',
        align: 'center',
      },
      {
        key: 'cancelaciones',
        title: 'Cancelaciones',
        dataIndex: 'cancelaciones',
        align: 'center',
      },
    ];
  }

  paginate(meta) {
    const { filters = {} } = this.props.hitsUsage;

    this.props.hitsUsageActions.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnAppNeedsRefresh = () => {
    this.paginate({ page: 1 });
  };

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selected: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.hitsUsage;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  handleOnDateChange = (date) => {
    const { filters } = this.props.hitsUsage;
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.hitsUsageActions.paginate({
      ...filters,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });

    this.setState({
      from: date[0],
      to: date[1],
    });
  };

  render() {
    const { columns, from, to } = this.state;
    const { data, busy } = this.props.hitsUsage;
    const { onRowClick } = this.props;

    return (
      <>
        {Guardian.allows('hits.listar') && (
          <>
            <div
              className="d-flex flex-column flex-sm-row"
              // style={{ backgroundColor: '#f8f9fa' }}
            >
              <CalendarDateRangePicker
                value={[from, to]}
                onDateChange={this.handleOnDateChange}
              />

              <Col className="text-right">
                <HitsUsageDownload />
              </Col>
            </div>
            <Row>
              <Col
                xs={true}
                sm={12}
              >
                <Table
                  loading={busy}
                  columns={columns}
                  rowKey={'id'}
                  data={data}
                  pagination={this.getPaginationConfig()}
                  // rowSelection={{
                  //   selectedRowKeys: selected,
                  //   ...this.getRowSelectionConfig(),
                  // }}
                  onRowClick={onRowClick}
                  onRow={(item) => {
                    return {
                      className: item.highlight ? 'row-highlighted' : '',
                    };
                  }}
                ></Table>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { hitsUsage: store.app.reports.hitsUsage };
};

const mapActions = (actions) => {
  return { hitsUsageActions: actions.app.reports.hitsUsage };
};

export default connect(useStore, mapState, mapActions)(HitsUsage);
